import React from "react"
import "../css/store-products.css"
import OnVisible from "react-on-visible"
import { HandleImages } from "../components/functions"

var terms = ["month", "annual"]

var features = {
  learningActivities: {
    MissionPlay: {
      image: <HandleImages name="missions" />,
      title: "Mission Play with Leaderboard and Team Chat",
      text: (
        <span>
          <strong>Learn by doing:</strong> Critical thinking is needed to defeat
          real threats on the range. Gain confidence as you solve more complex
          problems in offensive & defensive missions. Individual and team-based
          play includes network recon and confronting threats like botnets,
          phishing and exfiltration, ransomware, and many more.
        </span>
      ),
      overlay: (
        <div className="blocked">
          Available on:   <span id="e"> E</span>{" "}
        </div>
      ),
    },
    BattleRooms: {
      image: <HandleImages name="battleRooms" />,
      title: "Battle Rooms",
      text: (
        <span>
          <strong>Practice makes perfect:</strong> Hands-on in a virtualized
          cyber range. Build your skills in a series of multilevel learning
          challenges that reinforce cyber skills including Linux, scripting, and
          forensics.
        </span>
      ),
    },
    CyberGames: {
      image: <HandleImages name="regexStill" />,
      title: "Cyber Learning Games",
      text: (
        <span>
          <strong>Learn concepts</strong> Perfect your understanding of the
          basics. Master basic cyber security concepts with fun, arcade style
          games that teach cyber kill chain, ports and protocol, regular
          expression techniques, and more.
        </span>
      ),
    },
    MediaCenter: {
      image: <HandleImages name="mediaCenter" />,
      title: "Media Center",
      text: (
        <span>
          <strong> Cyber resources:</strong> The latest info on modern threats.
          Kickstart your cyber learning with 100+ hours of material in a curated
          collection of documents, web resources, and videos for all things
          cyber.
        </span>
      ),
    },
  },
  features: {
    Athena: {
      image: <HandleImages name="athena" />,
      title: "Athena, the AI Advisor for Mission Play",
      text: (
        <span>
          <strong>Get help:</strong> Need a tutor? Athena is ready to answer
          your questions. Progress through tight spots in your mission with
          guidance from Athena. Her suggestions are based on common questions
          asked across the Project Ares community. ​
        </span>
      ),
      overlay: (
        <div className="blocked">
          Available on:   <span id="e"> E</span>{" "}
        </div>
      ),
    },
    LearningPaths: {
      image: <HandleImages name="workRole" />,
      title: "Work Role Learning Paths",
      text: (
        <span>
          <strong>Align and identify: </strong> Measurable learning objectives
          are tied to NIST’s NICE framework and work roles to support skill gap
          analysis.​ ​
          <span class="roles">
            Cyber Defense Infrastructure Specialist, Cyber Defense Analyst,
            Systems Security Analyst, Threat Warning Analyst, Team Lead
          </span>
        </span>
      ),
    },

    ScoreReports: {
      image: <HandleImages name="scoreReports" />,
      title: "Score & Reports",
      text: (
        <span>
          <strong> Evaluate skills:</strong> Check out your performance in
          session playback. Look at the hints used to figure out the activities
          that need more practice. And use assessment reports to stay on track
          to complete work role learning paths.
          <br />
          <span class="infoAcademy">
            Individual reports. Session Playback for Battle Rooms.
          </span>
          <span class="infoPro">
            Individual reports. Session Playback for Battle Rooms and Missions.
          </span>
          <span class="infoPlus">
            Individual reports. Session Playback for Battle Rooms.
          </span>
          <span class="infoEnt">
            Individual reports. Session Playback for Battle Rooms and Missions.
          </span>
        </span>
      ),
    },

    GlobalChat: {
      image: <HandleImages name="globalChat" />,
      title: "Global Chat",
      text: (
        <span>
          <strong> Create connections: </strong> Join a community of Project
          Ares players. Chat about cyber security issues, in-game challenges,
          and leaderboard stats. Learn together.
          <br />
          <span class="infoAcademy">
            With other Academy players worldwide&#8203;.
          </span>
          <span class="infoPro">
            With other Professional players worldwide&#8203;.&#8203;
          </span>
          <span class="infoPlus">
            With other players aligned to organization or institution&#8203;
          </span>
          <span class="infoEnt">
            With other players aligned to organization or institution&#8203;
          </span>
        </span>
      ),
    },

    XP: {
      image: <HandleImages name="xP" />,
      title: "Experience Points",
      text: (
        <span>
          <strong> Level up: </strong> Gain experience points while improving
          cyber security skills. As you progress, collect all the skill badges
          and earn a coin the first time you complete each mission successfully.
        </span>
      ),
    },
  },

  sFeatures: {
    TrainerViewMission: {
      image: <HandleImages name="trainerViewA" />,
      title: "Trainer View for Mission Coaching",
      text: (
        <span>
          <strong>Observe and coach:</strong> Trainers can observe single or
          team mission play in real time or via session playback to coach
          players. And, because threats are unpredictable, trainers can create
          realistic challenges by joining live mission play as an unexpected
          adversary.
        </span>
      ),
      overlay: (
        <div className="blocked">
          Available on: <span id="e"> E</span>{" "}
        </div>
      ),
    },
    TrainerView: {
      image: <HandleImages name="trainerViewB" />,
      title: "Trainer View for Team or Class Performance",
      text: (
        <span>
          <strong>Analyze and assess: </strong> Manage cross-team skill gaps and
          build ROI with Trainer Tools to access group or class scores, activity
          data, and reports. Drill down to assess individual learning with
          single player reports and work role learning path data.
        </span>
      ),
      overlay: (
        <div className="blocked">
          Available on:  <span id="e"> E</span>{" "}
        </div>
      ),
    },
  },
}

class Products extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      active: 1,
      term: ["month", "month", "month", "month"],
      term1: "month",
      term2: "month",
      term3: "month",
      term4: "month",
      features: 1,
    }

    this.handleProductClick = this.handleProductClick.bind(this);
    this.handleProductsScroll = this.handleProductsScroll.bind(this);
    this.handleTermClick = this.handleTermClick.bind(this)
  }

  handleFeatures(features) {
    return Object.entries(features).map(function (child, index) {
      return (
        <div>
          {child[1].image}
          <h4> {child[1].title}</h4>
          <p>{child[1].text}</p>
          {child[1].overlay && child[1].overlay}
        </div>
      )
    })
  }

  handleProductsScroll(event) {
    var tempProducts=event.target;
    for (var i = 0; i < (tempProducts.children.length-1); i++) {
      tempProducts.children[i].getBoundingClientRect().left < 50
        ?     this.setState({ active:tempProducts.children[i].id }, ()=>{   tempProducts.children[i].classList.add("active");}) 
        :tempProducts.children[i].classList.remove("active")
      
     
    }
  }

  handleTermClick(event) {
    var temp =
      event.currentTarget.parentNode.parentNode.parentNode.parentNode.id

    this.setState({
      ["term" + temp]: event.currentTarget.value,
    })
  }

  handleProducts() {
    return (
      <div
        className={
          this.props.licenses == "individual"
            ? "products individual"
            : this.props.licenses == "org"
            ? "products org"
            : "products"
        }
        onScroll={this.handleProductsScroll}
      >
        <div
          className={this.state.active == 1 ? "active product" : "product"}
          onClick={this.handleProductClick}
          id="1"
        >
          <div className="card">
            <h4>Academy for Individuals</h4>
            <form>
              <label>
                $90.00 / Month
                <input
                  name="academy-month"
                  type="radio"
                  value={terms[0]}
                  checked={terms[0] == this.state.term1}
                  onClick={this.handleTermClick}
                />
                <span className="checkmark"></span>
              </label>
              <label>
                $900.00 / Annual
                <input
                  name="academy-year"
                  type="radio"
                  value={terms[1]}
                  checked={terms[1] == this.state.term1}
                  onClick={this.handleTermClick}
                />
                <span className="checkmark"></span>
              </label>
            </form>
            <a
              href={
                this.state.term1 == "month"
                  ? "https://circadence.recurly.com/subscribe/pa-aca-b2c-mo"
                  : "https://circadence.recurly.com/subscribe/pa-aca-b2c-ann"
              }
              target="_blank"
            >
              {" "}
              <button className="outlined-button">Buy Now</button>
            </a>
          </div>
          <div className="blurb">
            <p>
              <strong>Project Ares Academy:</strong> is designed for individuals
              who want foundational training in cyber security. Hands on games
              and exercises cover security concepts and basic cyber skills.​
            </p>
          </div>
        </div>
       {/* <div
          className={this.state.active == 2 ? "active product" : "product"}
          onClick={this.handleProductClick}
          id="2"
        >
          <div className="card">
            <h4>Professional for Individuals</h4>
            <form>
              <label>
                $450.00 / Month
                <input
                  name="academy-month"
                  type="radio"
                  value={terms[0]}
                  checked={terms[0] == this.state.term2}
                  onClick={this.handleTermClick}
                />
                <span className="checkmark"></span>
              </label>
              <label>
                $4,500.00 / Annual
                <input
                  name="academy-year"
                  type="radio"
                  value={terms[1]}
                  checked={terms[1] == this.state.term2}
                  onClick={this.handleTermClick}
                />
                <span className="checkmark"></span>
              </label>
            </form>
            <a
              href={
                this.state.term2 == "month"
                  ? "https://circadence.recurly.com/subscribe/pa-pro-b2c-mo"
                  : "https://circadence.recurly.com/subscribe/pa-pro-b2c-ann"
              }
              target="_blank"
            >
              {" "}
              <button className="outlined-button">Buy Now</button>
            </a>
          </div>
          <div className="blurb">
            <p>
              <strong> Project Ares Professional:</strong> is designed for
              individuals of all cyber skill levels. The Professional version
              expands upon Project Ares Academy by adding missions:
              multi-faceted cyber scenarios that require skill integration and
              strategic thinking.
            </p>
          </div>
            </div>*/}
{    /*    <div
          className={this.state.active == 3 ? "active product" : "product"}
          onClick={this.handleProductClick}
          id="3"
        >
          <div className="card">
            <h4>Academy Plus for Organizations</h4>
            <form>
              <label>
                $450.00 / Month
                <input
                  name="academy-month"
                  type="radio"
                  value={terms[0]}
                  checked={terms[0] == this.state.term3}
                  onClick={this.handleTermClick}
                />
              </label>
              <label>
                $4,500.00 / Annual
                <input
                  name="academy-year"
                  type="radio"
                  value={terms[1]}
                  checked={terms[1] == this.state.term3}
                  onClick={this.handleTermClick}
                />
              </label>
            </form>
            <a href="#" target="_blank">
              {" "}
              <button className="outlined-button">Contact Us</button>
            </a>
          </div>
          <div className="blurb">
            <p>
              <strong> Project Ares Academy Plus: </strong> is designed for
              organizations that need to provide foundational training in cyber
              security. Hands on games and exercises cover security concepts and
              basic cyber skills. Special features support group reporting for
              teams and classrooms. ​
            </p>
          </div>
</div>*/}
        <div
          className={this.state.active == 4 ? "active product" : "product"}
          onClick={this.handleProductClick}
          id="4"
        >
          <div className="card">
            <h4>Enterprise for Organizations</h4>
     {/*  <form>
              <label>
                $450.00 / Month
                <input
                  name="academy-month"
                  type="radio"
                  value={terms[0]}
                  checked={terms[0] == this.state.term4}
                  onClick={this.handleTermClick}
                />
              </label>
              <label>
                $4,500.00 / Annual
                <input
                  name="academy-year"
                  type="radio"
                  value={terms[1]}
                  checked={terms[1] == this.state.term4}
                  onClick={this.handleTermClick}
                />
              </label>
     </form>*/}
            <a href="/contact" target="_blank">
              {" "}
              <button className="outlined-button">Contact Us</button>
            </a>
          </div>
          <div className="blurb">
            <p>
              <strong> Project Ares Enterprise:</strong> is designed for organizations and education institutions that want to build and hone cyber skill levels at all levels.  <br/>

Concept-driven games and cyber skill exercises expand to real-world inspired threat scenarios that require skill integration and strategic thinking. Special features support group reporting for teams and classrooms and team play.  
            </p>
          </div>
        </div>
        <div className="bg">
          <OnVisible>
            <svg
              classclassName="group"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 583 366"
            >
              <path
                class="st0"
                d="M259.8 154.4c-6.5-11.5-11.8-23.6-17.5-35.5-8.7-18.1-6.4-16.9-25.5-16.9h-39.9c-6.5 0-7.9 2-5.6 8.1 5.9 15.2 12.1 30.3 18 45.5 1.4 3.5 3.6 3.8 6.9 3.8 21-.2 42 0 62.9-.2 3 0 4 1.2 5.1 3.8 3.7 9.2 4.5 19.1 6.1 28.7 4.6 28 8.8 56.1 13.2 84.1 1.9 12.2 3.7 24.5 5.7 36.8.4 2.2.1 4.8 2.4 6.2M477.9 203.6c-8.3-13.9-14.5-28.9-21.1-43.6-3.2-7.1-7.8-11-16.3-10.7-17.8.5-35.7.1-53.6.2-7.5 0-9.9 3.2-6.8 9.9 8.1 17.5 14.2 35.9 21.8 53.6M520.9 85.2c4.9 7.2 6.8 15.4 8.7 23.7 2.6 10.9 5.7 21.7 14.9 29.3 6.5 5.3 14 8 22.4 8.1 2.8 0 5.2-.9 6.2-3.7 1.1-2.9-1.5-3.6-3.1-5-4-3.5-5.7-8.4-7.4-13.1-3.1-8.4-6-17-8.8-25.5-5-15.4-16.4-22.4-33-19.2-2.8-5.5-7.6-8.5-13.7-10.2-4.2-1.2-7.9-1.2-11.9.1-7.8 2.7-10.3 9.1-6.2 16.2"
              />
              <path
                class="st0"
                d="M283.5 59.7c-11.9-.9-23.3.7-35 3.5-23.7 5.5-42.9-2.3-56.6-22.8-.7-1.1-2.1-2-2.4-3.1-2.9-11.9-12.8-14.3-22.5-16.8-3.9-1-7.6-3.3-11.8-2.4-.6 5 3.8 4.1 5.6 4.5 3.3.8 4.3 1.9 4.4 5.3.2 8.4 8.6 14.7 17.6 13.1 9.3 40.1 34.3 57.5 75.6 50.9-1.8 20-.7 38.9 3.3 57.6.3 1.2 0 2.5 0 3.7M179.4 227.9l-5.2 5.2c8.3 33.3 16.6 66.4 24.8 99.3-8.1 4.8-15.7 9.6-21 17.5-1.2 1.8-4 2.6-6.1 3.8M1.2 244.7c1.3 8.6 8.4 14.4 18.7 14.9 20.6.9 41.1 1.7 61.7 2.5 5.4.2 10.8.7 16.2.5 4.4-.1 6.3 2.1 8.2 5.6 4.5 8.4 3.3 17.4 2.9 26.2-.7 13.5-2.4 27-3.6 40.5-.5 5.3-1.8 10.2-4.3 15-2.8 5.3-.1 9.1 6.1 9.3 5.4.1 10.8 0 16.2 0M86.6 108.3c-15.3 10.1-31.7 18.6-44.3 32.4-21.6 23.7-35 51.5-41 82.9-.7 3.6-.1 7.5-.1 11.2M527.1 173.7c6 7.5 11.6 15.2 16.1 23.7 1.2 2.3 2.6 2.9 4.5 2.4 5.1-1.5 10.1-3.3 15.3-5.1-11-27.2-28.6-48.3-52.2-64.4-1.8-1.3-2.3-3-2.7-4-1.5-3.8-3.6-7.4-5.2-11.1M290.4 196.1c16.4 27.2 31.3 55.1 45.5 83.5 4.8 9.5 8.1 19.6 13.7 28.7M180.1 222.3c0 6.6 3 12.5 4.6 18.6 7.5 29.4 15.6 58.6 23.5 87.9.4 1.5 1.2 2.9 1.8 4.4M301.6 160.6c15.1-2.3 26.6-11.2 37.3-21.3 4.9-4.6 7.4-10.7 8.9-17.3 2.3-10.7.8-20.9-2-31.2-1-3.6-2.4-7.1-3.7-10.6-3-7.7-8.2-12.7-16.8-14.5-6.2-1.3-12.2-3.7-18.7-3.6M298.5 212.3c.6 9.8 1.2 19.5 1.9 29.3.8 11 1.9 22 2.4 33 .7 12.9.9 25.8 1.3 38.6 0 1.9 1 4.1-1.2 5.6"
              />
              <path
                class="st0"
                d="M342.1 229.8c6 14.7 11.7 29.7 18.3 44.1 2.3 5 2 8.5-.1 13.2-7.6 17.1-14.6 34.5-22 51.6-1.8 4.2-3 8.6-5.4 12.6-.9 1.4-2.2 4.3.5 5.4 2 .8 3.4-.2 4.5-2.9 3.8-9.7 8.4-19.1 12.1-28.8.7-1.8 3.4-2 1.2-5.6 5.7 3.7 9.8 4.6 13.3.1M453.6 230.4c-3.7 2.8-8.4 5.1-5.1 11.3.4.8-.6 2.5-1.2 3.7-10.2 19.5-17.2 40.2-23.7 61.1-1.8 5.6-3.7 11.2-5.6 16.8-.8 2.4-1.5 4.4-4.3 5.8-6.5 3.2-12.5 7.3-18.8 11.1M555.8 229.2c-3.2-1.4-6.7-.5-10-.5-28.9-.1-57.7-.1-86.6 0-1 0-2.3-.6-3.1.6M132.7 262.2c1.4-4.5.8-9.2.5-13.7-.4-5.8-4.4-8.8-9.8-10-12.8-2.8-25.7-4.8-38.6-6.2-7.9-.8-15.7-2.7-23.7-1.9M557 246c4.4 10.8 8.7 21.6 13.1 32.4.5 1.2 1.4 2.1.7 3.8-11.1 23.3-20.5 47.3-30.6 71-.2.4-.4.8-.7 1.2 4.1 3.4 4.4 3.6 6.2-.6 7.2-16.6 14.1-33.2 21.3-49.8 2.1-4.8 3.1-10.2 6.8-14.4M283.5 18.6c-2.6 6-4.3 12.2-5 18.7-.9 7.7 2.7 11.2 10.6 10.6 3.2-.2 6.3-1.4 8.6-3.3 2.9-2.3 5.7-3.8 9.4-4.4 3.2-.5 6.9-1.7 6.4-6.7-.1-1.6 1.9-3.3 2.9-5 3.1-5.2 3-6-2.5-9.2-1.1-.6-.9-1.2-1.2-2-2.7-7.1-8.7-9.4-15.5-10.6-3.5-.6-7.1-1.6-9.9-3.8-2.9-2.3-5.1-2.7-7.6.1-2.6 3-3 6.8-1.1 9.9 2.8 4.6 7.9 6.2 12.9 7.6 1.7.5 3.4.7 5 1.3 5.5 2 6 3.3 3.7 9.9M489.1 118.9c.6 1.9 1 3.9 1.9 5.6 2.1 3.8 1 6.3-1 10.2-4.6 8.8-8.5 18.1-11 27.9-2.6 10.5 2.9 17.8 8.9 24.9 4.6 5.5 9.7 10.7 15 15.6 3.9 3.6 9.7 1.8 14.3 3.8M70.4 120.1c10.2 6.8 20.5 13.6 25.5 25.5 2 4.6 4.5 9.1 6 13.8 6.4 19.3 20.6 31 37 41.1 2.6 1.6 6.7 2.2 5.6 6.8"
              />
              <path
                class="st0"
                d="M362 311.4c4.9 9.3 11 18 13.1 28.7 1.4 6.8 0 10.2-5.7 11.8-4.3 1.3-8.2-1.5-10.6-6.8-4-8.5-4.8-17.7-5.5-26.8-.3-3.4 2.5-5.5 4.9-7.5M453.6 229.2c-2-1.3-4.2-.6-6.2-.6-35.1.3-70.2-.6-105.3.4-4.3.1-8.7-.3-13.1-.4-10.3-.1-12.5-2-14.3-12.6 2.3-2.4 5.3-1.8 8.1-1.8H582M199.4 209.2c5.4 1.8 10.8-.6 16.2-.1 5 .5 8.5 5.1 7.5 10.1-.6 3-2.6 2.5-4.4 2.5-13.3-.3-26.6.6-39.9-.6-17.5-1.6-17.8-1.2-22.4 16.2-3.7 13.7-7.5 27.4-11.1 41.1-.3 1-.6 1.8-1.3 2.5"
              />
              <path
                class="st0"
                d="M197.5 208c-15.2 0-30.3-.2-45.5.1-11.6.2-23.3.7-34.9 1.2-4.2.2-6.3 3.3-6.3 8.1 0 5 3.6 3.6 6.3 3.7 14.1.4 28.3-.8 42.4.6M347.7 229.8c5.2 12 10.5 24.1 15.6 36.1 8.4 19.9 16.6 39.9 25 59.8 3.1 7.3 6.2 14.5 9.3 21.8M481 254.1c-2.9.3-5.8.5-8.7.8-.6 4.9 4.3 7.6 5.2 12.2 1.7 8.9.7 17.9 1.6 26.8.3 3.1 0 6.2.1 9.3.2 7.2 2.1 8.9 9.3 9.4 1 .1 2.1.4 3.8.8-1.5 10.6-5.1 20.4-11.4 29-3.2 4.4-15.4 4.3-22.2.4 3.6-2.3 5.7-6.3 11.2-3.7 3 1.4 6.7.3 8.8-4 2.4-5.3 3.8-10.7 4.7-16.3.3-1.8 1.6-3.2 1.4-5M167 235.4c1.3 10.4.5 20.8.4 31.6 1.3 1.5 3.2.9 5.6.3 1-10-.7-20.1.9-30M74.8 157.5c10 23.9 26.5 40.9 51.7 48.7.6.2.8 1.2 1.3 1.8M558.9 254.7c-5.3 1.6-10.6 2.5-16.2 2.5-16.4-.1-32.8-.2-49.2.1-5 .1-8.7-1.3-11.9-5-2-2.3-4.5-4.2-6.8-6.3M167 233.5c-.9 1.8-2.1 3.3-2.7 5.6-6.6 27.1-13.7 54-20.3 81.1-2.7 10.8-4.9 21.7-8 32.4-.6 2-1.7 4.5.1 6.9 3.5-.6 7.5.9 11.4-1.1-1.9-4.5-5.1-7.3-9.1-9.5M522.8 277.1v61.1M515.9 277.8v54.8c0 1.9.8 3.9-.6 5.6M335.2 229.8c5.8 16 11.6 32 17.5 48 1.5 4.2 3.3 8.3 5 12.5"
              />
              <path
                class="st0"
                d="M461.1 277.1c-8 15-19.2 27.6-29.3 41.1-2.2 3-4 6.3-7.3 8.2 1.6 4 1.7 7.9 4.1 11.2 2.3 3.2.7 6-3.6 6.7-8.7 1.4-17.4 2.5-26.7 3.8-.8 2.8 5.6 7.7-2.2 8.8-7.1-9.6-9.1-21.4-14.1-31.9-5.6-11.9-10.5-24.1-15.7-36.1M125.9 253.5c5.4 8.9 10.6 18 16.3 26.7 1.7 2.7 1.7 5.4 1 7.5-6.3 19.3-10 39.4-16.5 58.7-1.2 3.7-1.3 8-2.7 11.8M61.1 231.7c6.7 4.1 14.6 4.7 21.9 6.6 11.8 3 23.6 6.1 35.4 9M458 284.6c4.8 10.6 10.4 20.9 14 31.9 2.3 7-.5 14.5-4.1 21.1M544.6 340.1c-17.4-1.1-34.9-1.2-52.3.1-1.2.1-1.5 1.7-1.1 3.7h51.5M150.8 296.5c8.3 13.8 16.6 27.6 25.1 41.8-3.3 2.1-6.1 3.8-8.9 5.5M553.9 257.2c4 4.3 2.7 9.4 1.8 14.3-.9 4.8-4.9 5-8.7 4.9-7.7-.1-15.4 0-23.1-.4-9.1-.5-18.3.3-27.4.4-4.5.1-9.9.8-11.6-4.4-1.6-4.8-2.4-10.3 1.7-14.9M302.2 326.4c-7.2 2.2-8.6 1.3-10-6.4 3-2.1 6.2-.5 10.2-1.3-1.8 6.8 3.1 10.9 3.8 16.4.5 3.6-.8 4.9-3.4 4.9-10.8.1-21.7 1.3-32.4-1.1M84.1 179.3c-13.3 14.9-25.7 30.5-37.4 46.7-1 1.4-2.3 2.2-4.3 2.6-12.7 3.2-25.4 3.2-38.1-.1-.5-.1-1.2.4-1.9.6M390.7 229.8c-5.8 13.7-11.6 27.4-17.5 41.1-1 2.2-1.7 4.6-3.7 6.3M308.4 160.6c.4 1.7.8 3.3 1.4 5.8-14.1 3.2-28.2 4.4-42.6 2.9M317.8 100.8c-4.5 9.7-5.7 20.2-7.4 30.5-.8 5.1-2.6 10.2-1.3 15.6M309.7 167.5c6.4 9.1 8.9 20 13.6 30 2.4 5.1 3.8 10.8 5.7 16.2M384.4 229.8c-6 13.9-12 27.8-18.1 41.7M557 229.8c5.8 8.5 5.9 19.1 10.6 28 2.1 4 2.8 8.7 5.6 12.5"
              />
              <path
                class="st0"
                d="M126.5 305.8c-2.7 10.8-5.7 21.5-7.9 32.4-.7 3.6-2.6 6.6-4.3 9.1-2.5 3.8-7.1 3.1-10.9.2M480.4 208.6c12.3-.4 24.5.8 36.8-.6M115.9 113.3c-3.1.6-6.2 1.4-9.4 1.8-4.1.5-6.1-.6-5.8-5.6.2-4.4 1.3-8.7 1.6-13.1.2-4.6 5.5-7.3 9.9-5.6 3.3 1.2 6 3.5 10 3.3 4.6-.2 5.8-2.6 6.9-6.4 1.5-5.3-.7-9.1-4.5-11.7-2.7-1.9-6.6-2.4-9.2.6-4 4.6-8.1 4.8-12.5 1.1-2.8-2.3-5.8-1.6-8-.4-2.4 1.2-5.2 3.4-3.3 7.3 1.1 2.2-1.2 3.2-2.5 4.3-3.8 3.3-4.9 15.7-1.9 19.4 1.6 2.1 3.6 1.8 5.7 1.8M260.4 158.1c-.2-1-.4-2.1-.7-3.4 3.9-1.9 8-.8 12-.9 7.3-.2 14.5 0 21.8-.1 3.7 0 6.6 1.6 7.3 5 .7 3.6-2.1 5-5.4 6.4-6.6 2.8-12.2-.3-17.4-2.9-4.7-2.3-9-2.9-13.8-1.7M489.1 86.5c-5 4.8-8.2 10.7-10.1 17.4-2.5 9 2.9 14 11.9 13.8 10.6-.2 16.8-6.9 22.3-14.5 1.3-1.7.2-4.1-1.8-5.5-3.4-.3-3.7 4.3-6.8 4.4-2.5-1.7-1-3.9-.6-5.7.8-4.5-.3-8.7-3.9-11-3-1.9-7.2-3.4-10.5.4M198.8 334.5c4.5 8.1 4.4 9.2-1.9 14.3-6.2 5.1-12.4 10-18.5 15-4.5-.3-5.2-3.6-6.5-6.8-2.2-5.7-4.1-11.6-9.9-15M175.7 206.7c-3.1-5.7-9.7-9.2-15.6-8.1-5.3 1-10.8 1.5-15.6 4.3M214.3 175l-15 31.8M219.3 179.9c-4 9.6-9.7 18.5-12.5 28.7M426.2 335.1c-8.9 4.3-18.3 5.7-28 5"
              />
              <path
                class="st0"
                d="M501.6 202.4c-5.4.1-9.7-2.9-14.7-5.1-2.9 2.7-5.9 5.5-9 8.5.4 2.7 3.2 4.7 3.1 7.8M201.3 346.3c3 3.6 2.8 8.3 4.3 12.5 1 2.7 2.1 5.2 5 6.2 5.6-2.1 6.5-6.2 4.3-11.2-2.6-6.2-2.9-12.9-4.3-19.3M285.4 49.1c-.2 2.3-.5 4.6-.6 6.9-.5 8.2 4.2 12.7 12.5 11.8 8.1-.8 9.1-2.6 7.6-10.6-1.2-6.3-2.8-12.7-2-19.3M471.1 254.1c-1.4-.5-2.9-1-5-1.7.4 7.5-.7 14.3-2.5 21M581.3 254.7c-1.4 5.3-3.6 10.2-6.3 14.9-1.4 2.4-1 4 0 6.3 2.5 5.3 4.6 10.8 6.9 16.2M291.6 324.5c-3.1 1.2-6.2 2.6-9.4 3.7-6.1 2.1-11.2 5.3-14.3 11.2M543.3 200.5c-7.3 4.2-15.7 4.3-23.7 6.2M582 228.5c-7.5.4-15-.8-22.4.6M363.9 282.8c2 2.9 2.5 5.2.3 8.9-2.8 4.6-4.7 10.3-3.9 16 .4 2.5-1.8 1.2-2 2.2M180.7 30.4c-3.4-2.3-6.7-4.7-11.6-3.2 2.1 4.6 6.9 6.6 9.1 10.7M120.2 95.2c-2.7 9.4-2.1 19.3-4.4 28.6-2.5 10.2-3.1 10.4-12.4 6.9l-1.2-.6c-8.7-3.7-9.6-5-8.7-14.3.3-3.7.9-7.5 1.2-11.2.5-5.2-1.6-6.8-7.5-6.2M298.5 158.1c-5.9 3.8-12.5 1.5-18.7 1.5-1.6 0-2.4 1.2-3.7.9M215 61.6c-4.2 3.8-5.7 9-6.8 14.3-.3 1.6-.5 3.2-1.9 4.4M317.8 98.9c2.2 4.8 4.7 9.5 5.7 14.9 1.6 8.1-.1 15.2-4.5 21.8-3.5 5.3-7.1 10.6-12.5 14.3M572.6 284c2.7 6.2 5.3 12.5 8.2 18.6.6 1.2.1 2.2.5 3.2M562.6 196.1c2.8 5.4 6.7 10.8 1.2 16.8M509.1 130.1c-4.9 3.4-10.2 2.9-15.6 1.9M123.4 298.3c3.7 4.8 7.5 9.6 11.2 14.3M144.6 323.9c4.6 4.8 9.1 9.6 13.7 14.3M46.1 227.9c4.2 2.6 9.4 1.1 13.7 3.1M525.3 97.7c-2 4.1-2.2 9-5.6 12.5M134.6 360c-1.7 1.4-3.4 2.9-5.6 4.9-1.5-.3-3.1-2.5-5-4.2M320.9 135.7c3.5 3.3 4.3 8.3 7.5 11.8M260.4 80.2c-.6 3.7-1.2 7.5-1.9 11.2M506.6 112.6c3.5 4.4 7.1 2.7 10.6 0M306.6 34.1c.9-1.9 2.4-3.6 0-5.7s-2.7 1.6-4.4 1.3M582 268.4c-.7 3.5-2.7 6.3-4.4 9.3M125.2 346.9c-3.1-.3-6.3.7-9.3-.6M105.3 341.9c3.1.6 6.2 1.2 9.3 1.9M458.6 234.2c-2.5 2.4-6.9 2.3-8.1 6.2M524.6 213.6c.1-3.5-2-4.9-5-5.6M459.2 232.3c2.3 2.1 4.6 4.2 6.9 6.2M175.1 340.7c2 1.8 2.9 4.4 3.7 6.9M160.1 228.5c1.9 1.5 3.7 2.9 5.6 4.4M92.8 125.7c-1.9 1.7-3.7 3.3-5.6 5M304.1 152.5c-1.5 1-2.9 2.1-4.4 3.1M458 231.7c-.6-.4-1.2-.8-1.9-1.2M205.6 123.9c-3.5 5.5-3.4 7.7.6 11.2 2.5 2.2 5.2 1.4 6.2-1.9 1-3.2-2.2-8.1-6.2-9.3M420 173.7c-4.2 4.8-4.2 8.8 0 13.1 1 1.1 1.9 2.3 3.7 1.9 2.3-.6 2.9-2.6 3-4.4.3-4.8-1.1-8.8-6.1-10.6"
              />
            </svg>
            <svg
              classclassName="individual"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 675.5 474"
            >
              <path
                class="st0"
                d="M1 240.5c4.5 9.4 13.4 9.4 21.7 9.6 14 .4 28 .1 42 .1 1.7 0 4-.4 4.4 1.5 1.4 6.1 6.1 4.4 9.8 4.4 23.2.1 46.5 0 69.7 0 22.2 0 44.5-.1 66.7.1 5.5.1 9.1-1.6 11.3-6.8 9.1-22.2 16.9-44.9 26.9-66.8 2.4-5.2-1.4-9.6-8.2-9.7-14.2-.1-28.5 0-42.7 0-9.5 0-19 .2-28.5 0-8.1-.2-13.8 3.1-17.3 10.5-9.2 20-18.5 40-27.7 60-1.7 3.8-4.5 7-5.3 11.2M129.2 50.1c8.8-9.8 5.3-22.1-7.5-24.6s-21.2-1.1-29.4 11c-6.1 9.1-10.9 19.9-23 23.5-2.7.8-3.8 4.4-4.6 7.3-1.6 6.2-5.7 8.5-12 9.1C36.9 78.1 23.9 84.9 19 101c-4 13.1 0 21.3 12.7 27.9 7.1 3.7 8.8 7.5 7.7 15.7-.4 3.4-1.9 7.7 2.1 10.5M20.5 251.7c-4.5 8.7-8.9 17.6-13.5 26.2-2.8 5.2-4.2 10.8-4.3 16.5-.2 12.6 6 16.5 19.4 18.6 19.6 3.2 39.6 3.3 59.2 1.3 19.7-2 39.3-5.2 57.1-15.3 5.9-3.3 13.3-3.4 19.4-6.9M188.4 257.7c12 20.5 24.1 40.9 36 61.5 17.8 30.9 36.1 61.6 53.6 92.8 3.1 5.6 6.5 11.3 10.2 16.7M156.2 295.2c-2.7 23 8.4 41.5 19.5 60 11.9 19.9 26.8 37.6 40.8 56-3.2 4.9-7.5 7.8-12.4 9.9-5.2 2.3-5.9 5.3-2.3 9.8 12.9 15.9 28.2 29.3 44.3 41.9.3.2 1 0 1.5 0 2-6 2-6-1.5-14.3-5.3-12.7-10.9-25.3-15.6-38.3-2.7-7.4-3.6-15.4-5.4-23.2-2.5-10.5-5.1-21-7.4-31.5-.6-2.6-2.9-5.3-.8-8.2"
              />
              <path
                class="st0"
                d="M118 92c-1.7 6.7-3.6 13.5-5.2 20.3-.3 1.4-.1 3.4.7 4.4 11.3 13.6 15.8 30.6 21.1 46.7 4.2 12.7 1 25.9-9.1 36.7-8.2 8.8-16.4 17.6-24.8 26.1-1 1-2.7 1.7-2.3 3.7M174.9 257.7c10.4 15 16.3 32.1 23 48.8 5.9 14.6 11.3 29.5 15.3 44.9.7 2.6 3.1 4.4 5.7 6.3 8 5.6 15.2 12.2 22.6 18.5 2.6 2.2 2.5 5 0 7.4-2.2 2.1-4.4 4.1-6.7 6-4.9 4-5.5 8.2-.7 11.9 15.3 11.5 31.3 21.9 48.6 30.2 3.1 1.5 4.7-.4 6.8-1.6M60.2 184.3c-9.9 10.9-17.9 23-24.6 36.1-2.1 4-4.9 5.6-8.3 4.3-6.9-2.7-14.5-3.5-21.1-7.3"
              />
              <path
                class="st0"
                d="M34.7 226.2c17 7.9 35.1 8.7 53.2 7.3 8.4-.6 16.6-3.5 24.7-5.9 5.2-1.5 9.3-2 12.1 3.8 1.1 2.3 3.4 4 5.1 6M99.2 82.3c-2 5-4.2 9.9-6 15-3.5 9.9-7.5 18.1-16.9 25.2C47.9 143.8 24.9 170.3 10 203c-3.9 8.6-8 17.3-9.1 27M124.7 249.5c-15.7-1.7-31.5-.2-47.2-.8-3.1-.1-5.9.2-8.2 2.3M129.2 50.8c3.7 8.6 6.6 17.3 6.1 27-.5 10.9-8.5 16.2-18.9 12.8-13.3-4.3-19.5-14.7-24.7-26.4-.9-2.1.4-3.9 2.2-5.2 2-1.4 3.8-1.1 5.2.8 1.4 1.8 2.8 3.7 4.6 6 1-3 3.1-4.4 3.1-7.5-.1-5.9 3.6-9.7 8.8-12 5.3-2.4 9.2 0 12.7 3.8M198.9 223.2c8.5-7.2 9.3-14.3 2.2-19.5-9.2 6.4-10.4 13.9-3 19.5M238.7 388.2c9.3 10.1 20.7 17.6 32.3 24.7 2.2 1.3 4.5 3.2 7.5 1.5M156.9 257.7c-11.1 10.6-17.1 23.5-17.2 39M209.4 419.7c7.6 12.9 19 22.4 29.2 33 1.6 1.7 2.9 1.5 4.6.7M86.5 116.8c7.8 8.2 18.9 8.5 27 .7M389.5 203h27.3c15.7-13.2 26.9-45.8 26.9-63.4 0-11.9-5.1-22.6-13.3-30H376c-8.2 7.4-13.3 18.1-13.3 30-.1 17.6 11.2 50.2 26.8 63.4zM485.9 19.2c-4.5 0-7.8 12.1-12 12.9-4.4.9-12-9-16.1-7.3-4.1 1.7-2.5 14.1-6.2 16.5-3.7 2.5-14.5-3.7-17.6-.6-3.1 3.1 3.1 14 .6 17.6-2.4 3.7-14.8 2-16.5 6.2-1.7 4 8.2 11.7 7.3 16.1-.8 4.3-15.8 17.3-15.8 12 0-42.1 34.2-76.3 76.3-76.3 27.6 0 0-15.3 0-15.3-5.7 0-10.2 12.2-15.6 13.3-5.6 1.1-14.3-8.4-19.5-6.3-5.2 2.2-4.7 15.1-9.3 18.2-4.7 3.1-16.4-2.3-20.4 1.6-4 4 1.5 15.7-1.6 20.4-3.1 4.6-16.1 4.1-18.2 9.3-2.1 5.1 7.4 13.9 6.3 19.5-1.1 5.4-13.3 9.9-13.3 15.6 0 0-.6 3.5 10.6 8.8 1.2.6 2.3 2.9 2.3 2.9"
              />
              <path
                class="st0"
                d="M319.3 37.8c3.7-.8 8.5 8.5 12.1 8.4 3.7-.1 8.2-9.5 11.8-8.8 3.7.7 4.5 11.1 7.9 12.4 3.4 1.4 11.2-5.6 14.3-3.6 3.1 2-.1 11.9 2.6 14.5 2.6 2.6 12.5-.9 14.6 2.1 2.1 3-4.7 11-3.2 14.4 1.4 3.3 16 11.4 15 7-7.4-34.2-41.2-56.1-75.6-48.7-22.5 4.8-2.7-12.5-2.7-12.5 4.7-1 10.4 8.2 15 8.1 4.7-.1 10.2-9.4 14.8-8.6 4.6.9 6.5 11.5 10.8 13.2 4.4 1.7 13-4.8 16.9-2.2 3.9 2.5 1.5 13.1 4.9 16.4 3.3 3.2 13.8.5 16.5 4.4 2.6 3.8-3.6 12.6-1.7 17 .9 2.1 4 3.5 7 5M669.5 203h-361c-2.8 0-5 2.2-5 5s2.2 5 5 5h11v175.8c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5V213h329v175.8c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5V213h11c2.8 0 5-2.2 5-5s-2.2-5-5-5zM542.5 203h-62l24-66h62z"
              />
              <path
                class="st0"
                d="M535.1 190.2h-38l14.8-40.4h38zM556.5 166l5 37h-15M601.5 162h23v41h-23z"
              />
              <path class="st0" d="M601.5 168h23v5h-23z" />
            </svg>
          </OnVisible>
        </div>
      </div>
    )
  }

  handleProductClick(event) {
    this.setState({ active: event.currentTarget.id })
  }

  render() {
    console.log(this.state.active, this.state["term" + this.state.active])
    return (
      <div className="products-wrapper" id={"p" + this.state.active}>
        {this.handleProducts()}
        <div id={"f" + this.state.features} className="mobile-titles">
          <button
            className={
              this.state.features == 1 ? "flat-button" : "outlined-button"
            }
            onClick={() => this.setState({ features: 1 })}
          >
            Learning activities
          </button>

          <button
            className={
              this.state.features == 2 ? "flat-button" : "outlined-button"
            }
            onClick={() => this.setState({ features: 2 })}
          >
            Features
          </button>

          <button
            className={
              this.state.features == 3 ? "flat-button" : "outlined-button"
            }
            onClick={() => this.setState({ features: 3 })}
          >
            Special Features for Organizations
          </button>
        </div>
        <OnVisible percent={10} className="features-wrapper">
          <h3>Learning activities</h3>
          {this.handleFeatures(features.learningActivities)}

          <h3>Features</h3>
          {this.handleFeatures(features.features)}

          <h3>Special Features for Organizations</h3>
          {this.handleFeatures(features.sFeatures)}
        </OnVisible>
        <div className="repeat">{this.handleProducts()}</div>
      </div>
    )
  }
}

export default Products
